import Vue from 'vue';
import VueExcelEditor from 'vue-excel-editor';
import '@babel/polyfill';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';

// Must come first
import '@/plugins/composition';
import './plugins/mousetrap';
import vuetify from './plugins/vuetify';

import App from './App.vue';
import router from './router';
import store from './store';

// Must come after other imports
import './directives';

Vue.config.productionTip = false;

new Vue({
  router,
  store: store.original,
  vuetify,
  provide: { vuetify },
  render: (h) => h(App),
}).$mount('#app');

Vue.use(VueExcelEditor);
